import { ref, toRaw } from "vue";
import BuildingLevel from "@/roc/building/BuildingLevel";
import { useLayoutStore } from "@/roc/stores/LayoutStore";
import { useApplicationStore } from "@/roc/stores/ApplicationStore";
import EraType from "@/roc/era/EraType";
import Rect from "@/roc/grid/Rect";
import Grid from "@/roc/grid/Grid";
export default function () {
    const lytStore = useLayoutStore();
    const appStore = useApplicationStore();
    const relocationBackup = ref(null);
    const pendingBuilding = ref(null);
    const pendingBuildingRotation = ref(false);
    const pendingBuildingData = ref(null);
    return {
        pendingBuilding,
        pendingBuildingRotation,
        pendingBuildingData,
        startAddingNewBuilding(templateId) {
            const template = lytStore.getBuildingTemplateById(templateId);
            if (!template) {
                return;
            }
            pendingBuildingData.value = {
                x: 1,
                y: 1,
                rotate: false,
                level: BuildingLevel.calculateInitialLevel(template, appStore.selectedEra || EraType.stoneAge),
                era: template.era,
            };
            pendingBuilding.value = template;
            pendingBuildingRotation.value = false;
        },
        pickExistingBuilding(buildingId) {
            const building = lytStore.getBuildingById(buildingId);
            relocationBackup.value = toRaw(building);
            pendingBuilding.value = {
                ...building.template
            };
            pendingBuildingData.value = {
                ...building.placementInfo
            };
            pendingBuildingRotation.value = building.isRotated;
            lytStore.removeBuilding(buildingId);
        },
        rotatePickedBuilding() {
            pendingBuildingRotation.value = !pendingBuildingRotation.value;
        },
        placePickedBuilding(target) {
            const x = parseInt(target.style.left.replace('px', '')) / Grid.CELL_SIZE;
            const y = parseInt(target.style.top.replace('px', '')) / Grid.CELL_SIZE;
            let rotate;
            if (relocationBackup.value === null) {
                const template = lytStore.getBuildingTemplateById(target.dataset.buildingId || '');
                if (template) {
                    rotate = target.clientWidth !== Rect.toPixels(template.width);
                    lytStore.placeBuilding(template, {
                        x,
                        y,
                        rotate,
                        level: parseInt(target.dataset.buildingLevel || '1'),
                        era: BuildingLevel.calculateBuildingEraFromLevel(parseInt(target.dataset.buildingLevel || '1'), template, appStore.selectedEra || EraType.stoneAge),
                    });
                }
            }
            else {
                rotate = target.clientWidth !== Rect.toPixels(relocationBackup.value.width);
                lytStore.placeBuilding(relocationBackup.value.template, {
                    x,
                    y,
                    rotate,
                    level: relocationBackup.value.level,
                    era: relocationBackup.value.era
                });
                relocationBackup.value = null;
            }
            pendingBuilding.value = null;
            pendingBuildingData.value = null;
            setTimeout(() => {
                lytStore.updateHappiness();
            }, 100);
        },
        removePickedBuilding() {
            relocationBackup.value = null;
            pendingBuilding.value = null;
            pendingBuildingData.value = null;
        },
        undoPickBuilding() {
            if (relocationBackup.value !== null) {
                lytStore.addBuilding(relocationBackup.value);
                relocationBackup.value = null;
                setTimeout(() => {
                    lytStore.updateHappiness();
                }, 100);
            }
            pendingBuilding.value = null;
            pendingBuildingData.value = null;
        },
        duplicateAndPickPickedBuilding() {
            if (relocationBackup.value === null) {
                return;
            }
            const template = relocationBackup.value.template;
            const placementInfo = relocationBackup.value.placementInfo;
            if (relocationBackup.value !== null) {
                lytStore.addBuilding(relocationBackup.value);
                relocationBackup.value = null;
            }
            pendingBuilding.value = null;
            pendingBuildingData.value = null;
            setTimeout(() => {
                pendingBuildingData.value = {
                    x: 1,
                    y: 1,
                    rotate: placementInfo.rotate,
                    level: placementInfo.level,
                    era: placementInfo.era,
                };
                pendingBuilding.value = {
                    ...template
                };
                lytStore.updateHappiness();
            }, 100);
        }
    };
}
